import {
  lazy,
  Suspense,
  useState,
  useEffect,
  useMemo,
  useCallback,
  createContext,
} from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
const LoginView = lazy(() => import("views/login/index"));
const HomeView = lazy(() => import("layouts/index"));

const Ai = lazy(() => import("pages/ai/index"));
const AiEdit = lazy(() => import("pages/ai/edit/index"));
// const Carousel = lazy(() => import("pages/carousel/index"));
const QuestionNavigation = lazy(
  () => import("pages/question-navigation/index")
);
const BusinessNavigation = lazy(
  () => import("pages/business-navigation/index")
);
const BusinessNavigationImage = lazy(
  () => import("pages/business-navigation/edit/image-form")
);
const BusinessNavigationVideo = lazy(
  () => import("pages/business-navigation/edit/video-form")
);
const BusinessNavigationWeb = lazy(
  () => import("pages/business-navigation/edit/web-form")
);
const BusinessNavigationText = lazy(
  () => import("pages/business-navigation/edit/text-form")
);
const BusinessNavigationRichtext = lazy(
  () => import("pages/business-navigation/edit/richText-form")
);
const VideoManagement = lazy(() => import("pages/video-management/index"));
const ScreenAccount = lazy(() => import("pages/screen-account/index"));
const SeatingAccount = lazy(() => import("pages/seating-account/index"));
const SessionRecord = lazy(() => import("pages/session-record/index"));
type FallbackType = NonNullable<React.ReactNode> | null;
interface FallbackContextType {
  updateFallback: (fallback: FallbackType) => void;
}
const FallbackContext = createContext<FallbackContextType>({
  updateFallback: () => {},
});
const FabllbackProvider: React.FC = ({ children }) => {
  const [fallback, setFallback] = useState<FallbackType>(null);

  const updateFallback = useCallback((fallback: FallbackType) => {
    setFallback(() => fallback);
  }, []);

  const renderChildren = useMemo(() => {
    return children;
  }, [children]);

  return (
    <FallbackContext.Provider value={{ updateFallback }}>
      <Suspense fallback={fallback}>{renderChildren}</Suspense>
    </FallbackContext.Provider>
  );
};

function App() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/home/ai");
    }
  });
  return (
    <FabllbackProvider>
      <Routes>
        <Route path="/home" element={<HomeView />}>
          <Route path="ai" element={<Ai />} />
          <Route path="ai/:id" element={<AiEdit />} />
          <Route path="question-navigation" element={<QuestionNavigation />} />
          <Route path="business-navigation" element={<BusinessNavigation />} />
          <Route
            path="business-navigation-image/:id"
            element={<BusinessNavigationImage />}
          />
          <Route
            path="business-navigation-video/:id"
            element={<BusinessNavigationVideo />}
          />
          <Route
            path="business-navigation-web/:id"
            element={<BusinessNavigationWeb />}
          />
          <Route
            path="business-navigation-text/:id"
            element={<BusinessNavigationText />}
          />
          <Route
            path="business-navigation-richtext/:id"
            element={<BusinessNavigationRichtext />}
          />
          <Route path="video-management" element={<VideoManagement />} />
          <Route path="question-navigation/:id" element={<AiEdit />} />
          <Route path="screen-account" element={<ScreenAccount />} />
          <Route path="seating-account" element={<SeatingAccount />} />
          <Route path="session-record" element={<SessionRecord />} />
        </Route>
        <Route path="/login" element={<LoginView />} />
        <Route path="*" element={<div>error</div>} />
      </Routes>
    </FabllbackProvider>
  );
}

export default App;
